import script from "./StudentIdentification.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentIdentification.vue?vue&type=script&setup=true&lang=js"

import "./StudentIdentification.vue?vue&type=style&index=0&id=e6eeae0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6eeae0c"]])

export default __exports__